import { crdt } from '@w/crdt'
import { commitWorkspacePageEdit } from '../db/page-write'
import type { FlashcardsFeRouterCtx } from '../router/flashcards-fe.router-ctx'
import type { SpaceResource } from '../router/spaces-resources'
import type { RankedCard } from './kanban-order'
import { databaseSpaceRootOptions } from './database-space'
import { newPageDocument } from '../db/page-document'

/** Row model contract: custom id is the row page id; title belongs to pages. */
export async function createKanbanRow(resource: SpaceResource, input: { id: string; table: string; grouping: string; value: string | null; rank: string }) {
  const spaceId = await resource.queryClient.fetchQuery(databaseSpaceRootOptions(resource))
  const doc = newPageDocument({ title: 'Untitled page', content: { kind: 'databaseRow', children: [] }, deletedAt: null }, resource.userId)
  doc.edit(tx => { tx.set('content', 'kanbanRank', input.rank) })
  return resource.customDb.createDatabaseRow({ id: input.id, table: input.table, title: 'Untitled page', userId: resource.userId, spaceId, now: Date.now(), data: doc.encodeSnapshot().bytes, values: { [input.grouping]: input.value } })
}

export async function writeKanbanRanks(ctx: FlashcardsFeRouterCtx, resource: SpaceResource, ranks: readonly RankedCard[]) {
  for (const { id, rank } of ranks) {
    const [page] = await resource.customDb.query<{ data: Uint8Array }>('SELECT data FROM pages WHERE id=? AND deletedAt IS NULL', [id])
    if (!page) throw new Error('Row page no longer exists')
    const doc = crdt.load(page.data, { user: resource.userId })
    const version = doc.version()
    doc.edit(tx => { tx.set('content', 'kanbanRank', rank) })
    await commitWorkspacePageEdit(ctx, resource.space.id, { pageId: id, userId: resource.userId, frame: doc.encodeUpdate(version).bytes, now: new Date() })
  }
}
